/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'ap-southeast-1',
  aws_appsync_graphqlEndpoint:
    'https://6glnqmej6rcthfjbvqfxu4jnxa.appsync-api.ap-southeast-1.amazonaws.com/graphql',
  aws_appsync_region: 'ap-southeast-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-dg6wi6lp5regbhgvklpv5n422e',
  aws_cloud_logic_custom: [
    {
      name: 'record',
      endpoint: 'https://bkgi2hbsp4.execute-api.ap-southeast-1.amazonaws.com/main',
      region: 'ap-southeast-1',
    },
    {
        "name": "AdminQueries",
        "endpoint": "https://7avueoeqi0.execute-api.ap-southeast-1.amazonaws.com/main",
        "region": "ap-southeast-1"
    }
  ],
  aws_cognito_identity_pool_id:
    'ap-southeast-1:d73b265e-6fb6-43de-aded-846caa5c8675',
  aws_cognito_region: 'ap-southeast-1',
  aws_user_pools_id: 'ap-southeast-1_Fp5el2fEp',
  aws_user_pools_web_client_id: '5apr9f10be8cqpi03bdo7bk6t0',
  oauth: {},
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default awsmobile;
